/* 扫描所有语言文件,并将子工程的对象加入相应的语言文件中 */
const requireComponent = require.context('./language', false, /\.json$/);
requireComponent.keys().forEach(fileName => {
    const componentConfig = requireComponent(fileName);
    if (window.messages[componentConfig.language.id] != undefined) {
        for (var obj in componentConfig) {
            if (obj != 'language') {
                window.messages[componentConfig.language.id][obj] = componentConfig[obj];
            }
        }
    }
});
